import { ReactElement } from 'react';
import { Card, Typography } from 'antd';
import AudioPlayer from './AudioPlayer';
import { UseAudioPlayerReturn } from '../../hooks/useAudioPlayer';

interface Props {
  duration: number | null;
  isAudioAvailable: boolean;
  audioPlayer: UseAudioPlayerReturn;
}

const AudioSection = ({ duration, isAudioAvailable, audioPlayer }: Props): ReactElement => {
  if (!isAudioAvailable) {
    return (
      <Card size='small'>
        <Typography.Text type='secondary'>録音データは保管期間を過ぎたため削除されました。</Typography.Text>
      </Card>
    );
  }

  return <AudioPlayer duration={duration} audioPlayer={audioPlayer} />;
};

export default AudioSection;
